var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgXDeactivate = function SvgXDeactivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1rem",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x-deactivate_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M12.4 0H3.6C1.6 0 0 1.6 0 3.6v8.8c0 2 1.6 3.6 3.6 3.6h8.8c2 0 3.6-1.6 3.6-3.6V3.6c0-2-1.6-3.6-3.6-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.878 7.183 3.886-4.516h-.92L8.468 6.588 5.775 2.667H2.667l4.075 5.93-4.075 4.736h.92L7.15 9.192l2.846 4.141h3.108l-4.226-6.15ZM7.618 8.65l-.414-.59-3.285-4.7h1.415l2.65 3.793.414.59 3.446 4.93h-1.415L7.617 8.649Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "x-deactivate_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgXDeactivate;